// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-icon{max-width:54px}@media (min-width:992px){.x-icon{max-width:72px}}", ""]);
// Exports
module.exports = exports;
